import type {
  IEngagementTeaser,
  IImpressionTeaser,
} from '@schibsted/pulse-sdk';
import type { WrappedTeaser } from '../../../views/components/teasers/TeaserWrapper.js';

import { accessLevel } from '../../../../core/utils/access.js';
import { getImageUrl } from '../../../views/components/commonComponents/imageUtils.js';
import { getPulseTargetBaseUrl } from '../pulse-target-base-url.server.js';

type TeaserEvent = IImpressionTeaser | IEngagementTeaser;
type TeaserPageContent = NonNullable<TeaserEvent['page']['content']>;

export const toAbsoluteUrl = (href: string): string =>
  href.startsWith('http') ? href : `${getPulseTargetBaseUrl()}${href}`;

export const getElementSize = (
  size: WrappedTeaser['size'],
): TeaserEvent['object']['elementSize'] => {
  switch (size) {
    case 'small':
      return 'S';
    case 'big':
      return 'L';
    default:
      return 'M';
  }
};

export const getContentAccessLevel = (
  teaser: WrappedTeaser,
): TeaserPageContent['accessLevel'] => {
  if ('access' in teaser) {
    return accessLevel(teaser.access);
  }

  return 'Free';
};

export const getTeaserTitle = (teaser: WrappedTeaser): string =>
  'title' in teaser ? teaser.title : teaser.properties.title;

export const getTeaserImageUrl = (
  teaser: WrappedTeaser,
  width = 576,
  height = 384,
): string | undefined => {
  if ('properties' in teaser) {
    return teaser.properties.image
      ? getImageUrl(teaser.properties.image, width, height)
      : undefined;
  }

  if (teaser.imageUrl) {
    return teaser.imageUrl;
  }

  if ('image' in teaser && teaser.image) {
    return getImageUrl(teaser.image.id, width, height);
  }

  if ('imageId' in teaser && teaser.imageId) {
    return getImageUrl(teaser.imageId, width, height);
  }

  return undefined;
};
